<template>
  <div>
    <v-col
      v-if="downloading"
      class="subtitle-1 text-center"
      cols="12"
    > <span class="hidden-sm-and-down">Cargando por favor espere...</span>
    </v-col>
    <v-progress-linear
      indeterminate
      :background-color="backgroundLoadingColor"
      :color="loadingColor"
      height="10"
      v-if="downloading"
    ></v-progress-linear>
    <v-data-table
      :headers="headers"
      :items="items"
      :options.sync="options"
      :server-items-length="totalItems"
      :loading="loading"
      loading-text="Cargando..."
      :class="`elevation-1 ${navbarColor}`"
      item-key="id"
      :footer-props="footerOptions"
    >
      <template v-slot:top>
        <v-toolbar
          flat
          color="white"
        >
          <back-button v-if="back" />
          <v-toolbar-title v-html="title" />
          <v-divider
            class="mx-4"
            inset
            vertical
          />
          <v-spacer />
          <v-btn
            v-if="refresh"
            @click="reload"
            elevation="1"
            :loading="noReload"
            :color="themeColor"
            dark
          >
            <v-icon>mdi-reload</v-icon><span class="hidden-sm-and-down">REFRESCAR</span>
          </v-btn>
          <slot name="filters" />
          <v-spacer />
          <v-text-field
            v-if="!islazySearch"
            v-on:input="debounceInput"
            label="Buscar"
            single-line
            hide-details
          />
          <v-divider
            class="mx-4"
            inset
            vertical
          />
          <slot name="actions-filters" />
          <slot name="automatic" />
          <v-btn
            v-if="!readonly && can(permisosNuevoRegistro)"
            :color="themeColor"
            dark
            class="mb-2"
            @click="newItem()"
          >
            <v-icon>mdi-plus</v-icon><span class="hidden-sm-and-down">NUEVO REGISTRO</span>
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item.active="{ item }" v-if="isUsers">
        <div v-if="item.active === 1">
           <v-switch
              :color="themeColor"
              v-model="item.active"
              :loading="toggleStatus"
              @click.prevent="openModalStatus(item)"
            />
        </div>
        <div v-else>
          <v-tooltip bottom color="error">
            <template v-slot:activator="{ on }">
             <v-switch
              :color="themeColor"
              v-model="item.active"
              v-on="on"
              :loading="toggleStatusForm"
              @click.prevent="openModalStatusForm(item)"
            />
            </template>
            <span><b>Motivo:</b> {{ item.observation }} </span><br>
          </v-tooltip>
        </div>
      </template>
      <template v-slot:item.active="{ item }" v-else>
        <div v-if="isNumeration === false">
          <v-switch
            :color="themeColor"
            v-model="item.active"
            :loading="toggleStatus"
            @click.prevent="openModalStatus(item)"
          />
        </div>
        <div v-if="isNumeration === true">
          <v-switch
            :color="themeColor"
            v-model="item.active"
            :loading="toggleStatus"
            @click.prevent="openModalStatusNumeration(item)"
          />
        </div>
        </template>
      <slot name="filter">
        Default
      </slot>
      <template v-slot:item.receiver_number_id="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <span
              v-bind="attrs"
              v-on="on"
            >{{ item.receiver_number_id }}</span>
          </template>
          <span>{{ item.receiver_name }}</span>
        </v-tooltip>
      </template>
      <template v-slot:item.external_number_id="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <span
              v-bind="attrs"
              v-on="on"
            >{{ item.external_number_id }}</span>
          </template>
          <span>{{ item.external_name }} - {{ item.external_type }} - {{ item.external_email }}</span>
        </v-tooltip>
      </template>
      <template v-slot:item.document_number="{ item }">
        {{item.document_number.toString().padStart(8, '0') }}
      </template>
      <template v-slot:item.type_app="{ item }">
        <span v-if="item.type_app == 1">INTEGRACIÓN</span>
        <span v-else>APP</span>
      </template>
      <template v-slot:item.status_salebook="{ item }">
        <div v-if="item.status == 1">
          <v-chip
            color="green"
            dark
          >
            PROCESADO
          </v-chip>
        </div>
        <div v-else>
          <v-chip
            color="red"
            dark
            v-on="on"
          >
            PENDIENTE
          </v-chip>
        </div>
      </template>
      <template v-slot:item.notify_status="{ item }">
        <div v-if="item.notify_status == 1">
          <v-chip
            color="green"
            dark
          >
            VISTO
          </v-chip>
        </div>
        <div v-else>
          <v-chip
            color="red"
            dark
            v-on="on"
          >
            PENDIENTE
          </v-chip>
        </div>
      </template>
      <template v-slot:item.status="{ item }" v-if="!isBatches">
        <div v-if="item.status.indexOf('1') !== -1">
          <v-chip
            :color="getColor(item.status)"
            dark
          >
            ENVIADA
          </v-chip>
        </div>
        <div v-else>
          <v-tooltip bottom color="error" v-if="isDocuments">
            <template v-slot:activator="{ on }">
              <v-chip
                :color="getColor(item.status)"
                dark
                v-on="on"
              >
                ANULADA
              </v-chip>
            </template>
            <span><b>Fecha de Anulación:</b> {{ item.dateAnnulment }} </span><br>
            <span><b>Motivo:</b> {{ item.reason }}</span>
          </v-tooltip>
          <v-chip
            :color="getColor(item.status)"
            dark
            v-on="on"
            v-else
          >
            ANULADA
          </v-chip>
        </div>
      </template>
      <template v-slot:item.status="{ item }" v-else>
        <div v-if="item.status === '200-Procesado'">
          <v-chip
            color="green"
            dark
          >
            PROCESADO
          </v-chip>
        </div>
        <div v-if="item.status === '100-Repetido'">
          <v-chip
            color="red"
            dark
          >
            REPETIDO
          </v-chip>
        </div>
        <div v-if="item.status === '95-Procesando'">
          <v-chip
            color="orange"
            dark
          >
            PROCESANDO
          </v-chip>
        </div>
      </template>
      <template v-slot:item.type="{ item }">
        <span v-if="item.type == 1 && item.parameters != null">MENSAJES DE TEXTO</span>
        <span v-else-if="item.type == 2 && (item.whatsapp_provider == 1 || item.whatsapp_provider == 2)">WHATSAPP</span>
        <span v-else-if="item.type == 1">FACTURA</span>
        <span v-else-if="item.type == 2">IMPORTACIÓN</span>
        <span v-else-if="item.type == 3">EXPORTACIÓN</span>
        <span v-else-if="item.type == 4">REFERENTE (NC)</span>
        <span v-else-if="item.type == 5">REFERENTE (ND)</span>
        <span v-else-if="item.type == 6">NOTA DE CRÉDITO</span>
        <span v-else-if="item.type == 7">NOTA DE DÉBITO</span>
        <span v-else-if="item.type == 8">ZONA FRANCA</span>
        <span v-else-if="item.type == 9">REEMBOLSO</span>
      </template>
      <template v-slot:item.whatsapp_provider="{ item }">
        <span v-if="item.whatsapp_provider == 0">WAHA</span>
        <span v-else-if="item.whatsapp_provider == 1">BSP</span>
      </template>
      <template v-slot:item.action_documents="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon
              :color="themeColor"
              dark
              @click="getGeneralAction(item)"
              v-on="on"
              :loading="busy"
            >
              mdi-cog
            </v-icon>
          </template>
          <span>Presiones aquí para ver más opciones</span>
        </v-tooltip>
        <v-tooltip bottom
          v-if="item.status.indexOf('1') !== -1 && !(item.comment_receipt === undefined || item.comment_receipt === null)"
        >
          <template v-slot:activator="{ on }">
            <v-icon
              color="green darken-1"
              dark
              @click="getReceipt(item)"
              v-on="on"
              :loading="busy"
            >
              mdi-thumb-up
            </v-icon>
          </template>
          <span>Acuse de Recibo</span>
        </v-tooltip>
      </template>
      <template v-slot:item.action_salebook="{ item }">
        <v-tooltip bottom v-if="item.status == 1">
          <template v-slot:activator="{ on }">
            <v-icon
              :color="themeColor"
              dark
              @click="getExcel(item)"
              v-on="on"
              :loading="busy"
            >
              mdi-file
            </v-icon>
          </template>
          <span>Excel</span>
        </v-tooltip>
        <v-tooltip bottom v-else>
          <template v-slot:activator="{ on }">
            <v-icon
              color="red darken-1"
              dark
              v-on="on"
              :loading="busy"
            >
              mdi-file
            </v-icon>
          </template>
          <span>Pendiente</span>
        </v-tooltip>
      </template>
      <template v-slot:item.action="{ item }">
        <slot
          v-if="hasActionsSlot()"
          name="actions"
          :item="item"
        />
        <div v-else>
        <v-tooltip bottom >
          <template v-slot:activator="{ on }">
            <v-icon
            v-if="(isNumeration)"
              :color="themeColor"
              dark
              @click="openModalPass(item)"
              v-on="on"
            >
              mdi-file-document-outline
            </v-icon>
          </template>
          <span>Articulo 32</span>
        </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                v-if="(!isNumeration && !readonlyEditar && can(permisosEditar)) ||
                  (isNumeration && !readonlyEditar && can(permisosEditar) && item.editable == 1)"
                :color="themeColor"
                dark
                @click="editItem(item)"
                v-on="on"
              >
                mdi-pencil
              </v-icon>
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                v-if="(!isNumeration && !readonlyEliminar && can(permisosEliminar)) ||
                  (isNumeration && !readonlyEliminar && can(permisosEliminar) && item.editable == 1)"
                :color="themeColor"
                dark
                @click="openModalDelete(item)"
                v-on="on"
              >
                mdi-delete
              </v-icon>
            </template>
            <span>Eliminar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                v-if="can(permisosAsociaciones)"
                :color="themeColor"
                @click="detailItem(item)"
                v-on="on"
              >
                mdi-clipboard-text-search
              </v-icon>
            </template>
            <span>Ver Detalle</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                v-if="can(permisosDescargar)"
                :color="themeColor"
                @click="downloadItem(item)"
                v-on="on"
              >
                mdi-download
              </v-icon>
            </template>
            <span>Descargar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                v-if="!readonlyEditar && can(permisosNuevoMovimiento)"
                :color="themeColor"
                @click="openModalMovements(item)"
                v-on="on"
              >
                mdi-swap-horizontal
              </v-icon>
            </template>
            <span>Movimientos</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                v-if="!readonlyEditar && can(permisosHistorial)"
                :color="themeColor"
                @click="historyItem(item)"
                v-on="on"
              >
                mdi-file
              </v-icon>
            </template>
            <span>Historial</span>
          </v-tooltip>
        </div>
      </template>
      <template v-slot:footer>
        <slot name="footer" />
      </template>
      <template v-slot:no-data>
        <v-label>No se encontraron resultados.</v-label><br>
        <v-btn
          :color="themeColor"
          dark
          @click="reset"
        >
          Limpiar búsqueda
        </v-btn>
      </template>
    </v-data-table>
    <v-dialog
      v-model="dialogStatus"
      max-width="750"
    >
      <v-card>
        <v-card-title class="headline">
          ¿Estás seguro de que quieres cambiar el estado de este registro?
        </v-card-title>
        <v-container v-if="isUsers">
            <v-form
              ref="form3"
              lazy-validation
              @keydown="form3.onKeydown($event)"
            >
              <v-row>
                <v-col>
                  <v-card-text>
                    <v-text-field
                      v-model="form3.observation"
                      label="Motivo"
                      maxlength="500"
                      :rules="[rules.required]"
                    />
                  </v-card-text>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="error darken-1"
            text
            @click="dialogStatus = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            :loading="toggleStatus"
            @click.prevent="validateMotivo()"
            v-if="isUsers"
          >
            Aceptar
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            :loading="toggleStatus"
            @click.prevent="toggleActive()"
            v-else
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogStatusForm"
      max-width="750"
    >
      <v-card>
        <v-card-title class="headline">
          ¿Estás seguro de que quieres cambiar el estado de este registro?
        </v-card-title>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="error darken-1"
            text
            @click="dialogStatusForm = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            :loading="toggleStatusForm"
            @click.prevent="toggleActiveUser()"
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialog"
      max-width="620"
    >
      <v-card>
        <v-card-title class="headline">
          ¿Estás seguro de que quieres eliminar este registro?
        </v-card-title>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="red darken-1"
            text
            @click="dialog = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            :loading="toggleStatusDelete"
            @click.prevent="deleteItem()"
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-if="dialogShowEmail"
        v-model="dialogShowEmail"
        max-width="700"
      >
        <v-card>
          <v-card-title class="headline">
            Enviar {{ form2.send_type }}
          </v-card-title>
          <v-card-subtitle class="headline" v-if="item !== null" >
            <h5>Documento: {{item.document_number.toString().padStart(8, '0')}}</h5>
            <h5>Serie: {{item.serie}}</h5>
            <h5>Numero de Control: {{item.control_number}}</h5>
            <h5>Fecha: {{item.issue_date}}</h5>
            <h5 v-if="item.status.indexOf('1') !== -1">
              Estado: Enviada
            </h5>
            <h5 v-else>
              Estado: Anulada
            </h5>
          </v-card-subtitle>
          <v-container>
            <v-form
              ref="form"
              lazy-validation
              @submit.prevent="reset"
              @keydown="form.onKeydown($event)"
            >
              <v-row>
                <v-col style="padding: 0 32px !important">
                  <v-select
                    v-model="form2.send_type"
                    :items="itemsTypeSend"
                    :rules="[rules.required]"
                    label="Seleccione la modalidad de envío"
                    required
                  />
                </v-col>
              </v-row>
              <v-row v-if="form2.send_type === 'correo'">
                <v-col style="padding: 0 32px !important">
                  <v-text-field
                    v-model="form2.mail"
                    label="Puede agregar uno o varios correos, separados por coma (,)"
                    :rules="[rules.required]"
                    maxlength="500"
                    required
                  />
                </v-col>
              </v-row>
              <v-row v-if="form2.send_type === 'sms'">
                <v-col style="padding: 0 32px !important">
                  <v-text-field
                    v-model="form2.number_phone"
                    label="Agregar un número telefono"
                    :rules="[rules.required, rules.phoneLength]"
                    maxlength="16"
                    v-mask="'####-###-#######'"
                    placeholder="0058-414-1234567"
                    type="tel"
                    required
                  />
                </v-col>
              </v-row>
              <v-row v-if="form2.send_type === 'whatsapp'">
                <v-col style="padding: 0 32px !important">
                  <v-text-field
                    v-model="form2.number_phone"
                    label="Agregar un número telefono"
                    :rules="[rules.required, rules.wsLength]"
                    maxlength="14"
                    v-mask="'##-###-#######'"
                    placeholder="58-414-1234567"
                    type="tel"
                    required
                  />
                </v-col>
              </v-row>
            </v-form>
          </v-container>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="error darken-1"
              text
              @click="dialogShowEmail = false"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="green darken-1"
              text
              :loading="form2.busy"
              @click.prevent="sendType()"
            >
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
    </v-dialog>
    <v-dialog
        v-if="dialogShowSMS"
        v-model="dialogShowSMS"
        max-width="700"
      >
        <v-card>
          <v-card-title class="headline">
            Enviar mensaje de texto
          </v-card-title>
          <v-card-subtitle class="headline" v-if="item !== null" >
            <h5>Documento: {{item.document_number.toString().padStart(8, '0')}}</h5>
            <h5>Serie: {{item.serie}}</h5>
            <h5>Numero de Control: {{item.control_number}}</h5>
            <h5>Fecha: {{item.issue_date}}</h5>
            <h5 v-if="item.status.indexOf('1') !== -1">
              Estado: Enviada
            </h5>
            <h5 v-else>
              Estado: Anulada
            </h5>
          </v-card-subtitle>
          <v-container>
            <v-form
              ref="form"
              lazy-validation
              @submit.prevent="reset"
              @keydown="form.onKeydown($event)"
            >
              <v-row>
                <v-col>
                  <v-card-text>
                    <v-text-field
                      v-model="form5.number_phone"
                      label="Agregar un número telefono"
                      :rules="[rules.required, rules.phoneLength]"
                      maxlength="16"
                      v-mask="'####-###-#######'"
                      placeholder="0058-414-1234567"
                      type="tel"
                      required
                      />
                  </v-card-text>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="error darken-1"
              text
              @click="dialogShowSMS = false"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="green darken-1"
              text
              :loading="form5.busy"
              @click.prevent="sendSMS()"
            >
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
    </v-dialog>
    <v-dialog
        v-if="dialogGeneralAction && !isUsers"
        v-model="dialogGeneralAction"
        max-width="700"
    >
      <v-card>
        <v-card-title class="headline" v-if="item !== null" >
            <p>Acciones</p>
        </v-card-title>
        <v-card-subtitle class="headline" v-if="item !== null" >
          <h5>Documento: {{item.document_number.toString().padStart(8, '0')}}</h5>
          <h5>Serie: {{item.serie}}</h5>
          <h5>Numero de Control: {{item.control_number}}</h5>
          <h5>Fecha: {{item.issue_date}}</h5>
          <h5 v-if="item.status.indexOf('1') !== -1">
            Estado: Enviada
          </h5>
          <h5 v-else>
            Estado: Anulada
          </h5>
        </v-card-subtitle>
        <v-container>
          <v-tooltip bottom class="mr-3">
            <template v-slot:activator="{ on }">
              <v-btn
                v-if="can('descargar_json')"
                color="purple darken-1"
                dark
                @click="getJson(item)"
                v-on="on"
                :loading="busy"
                class="mr-3"
              >
                Descargar JSON
                <v-icon>mdi-file</v-icon>
              </v-btn>
            </template>
            <span>Descargar JSON</span>
          </v-tooltip>
          <v-tooltip bottom class="mr-3">
            <template v-slot:activator="{ on }">
              <v-btn
                v-if="can('descargar_xml')"
                color="pink darken-1"
                dark
                @click="getXML(item)"
                v-on="on"
                :loading="busy"
                class="mr-3"
              >
                Descargar XML
                <v-icon>mdi-file-xml</v-icon>
              </v-btn>
            </template>
            <span>Descargar XML</span>
          </v-tooltip>
          <v-tooltip bottom class="mr-3">
            <template v-slot:activator="{ on }">
              <v-btn
                v-if="can('descargar_pdf')"
                :color="themeColor"
                dark
                @click="getPDF(item)"
                v-on="on"
                :loading="busy"
                class="mr-3"
              >
                Descargar PDF
                <v-icon>mdi-file-pdf</v-icon>
              </v-btn>
            </template>
            <span>Descargar PDF</span>
          </v-tooltip>
        </v-container>


        <v-container>
          <v-tooltip bottom class="mr-3">
            <template v-slot:activator="{ on }">
              <v-btn
                v-if="can('enviar_correo') || (can('enviar_sms') && item.send_sms === 1) || (can('enviar_whatsapp') &&
                (item.send_whatsapp === 1 || item.send_whatsapp === 2))"
                color="orange darken-1"
                dark
                v-on="on"
                :loading="busy"
                class="mr-3"
                @click="getMail(item, can('enviar_correo'), (can('enviar_sms') && item.send_sms === 1),
                          (can('enviar_whatsapp') && (item.send_whatsapp === 1 || item.send_whatsapp === 2)))"
              >
                Enviar
                <v-icon>mdi-send</v-icon>
              </v-btn>
            </template>
            <span>Enviar</span>
          </v-tooltip>
          <v-tooltip bottom class="mr-3">
            <template v-slot:activator="{ on }">
              <v-btn
                v-if="can('historial_correo')"
                color="grey darken-1"
                dark
                @click="trackingMail(item)"
                v-on="on"
                :loading="busy"
                class="mr-3"
              >
                Historial de Envio
                <v-icon>mdi-book-open</v-icon>
              </v-btn>
            </template>
            <span>Historial de Envio</span>
          </v-tooltip>
          <v-tooltip bottom class="mr-3">
            <template v-slot:activator="{ on }">
              <v-btn
                :color="themeColor"
                dark
                @click="getGeneralActionPdf(item)"
                v-on="on"
                :loading="busy"
                class="mr-3"
              >
                Previsualizar PDF
                <v-icon> mdi-file-eye</v-icon>
              </v-btn>
            </template>
            <span>Previsualizar PDF</span>
          </v-tooltip>
        </v-container>

        <v-container>
          <v-tooltip bottom class="mr-3">
            <template v-slot:activator="{ on }">
              <v-btn
                v-if="can('descargar_json')"
                color="teal darken-1"
                dark
                @click="redirectToConsulta(item)"
                v-on="on"
                :loading="busy"
                class="mr-3"
              >
                Portal Consulta
                <v-icon>mdi-file</v-icon>
              </v-btn>
            </template>
            <span>Portal Consulta</span>
          </v-tooltip>
        </v-container>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="error darken-1"
            text
            @click="dialogGeneralAction = false"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
    v-if="dialogGeneralActionPdf && !isUsers"
    v-model="dialogGeneralActionPdf"
    max-width="700"
    >
      <v-card>
        <v-card-title class="headline" v-if="item !== null" >
            <p>PDF</p>
        </v-card-title>

        <v-container>
          <iframe
          :src="linkSourcePdf"
          width=100% height=600></iframe>

        </v-container>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="error darken-1"
            text
            @click="dialogGeneralActionPdf = false"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-if="dialogReceipt && !isUsers"
        v-model="dialogReceipt"
        max-width="700"
      >
        <v-card>
          <v-card-title class="headline" v-if="item !== null">
             <p>Acuse de Recibo</p>
          </v-card-title>
          <v-card-subtitle class="headline" v-if="item !== null" >
            <h5>Documento: {{item.document_number.toString().padStart(8, '0')}}</h5>
            <h5>Serie: {{item.serie}}</h5>
            <h5>Numero de Control: {{item.control_number}}</h5>
            <h5>Fecha: {{item.issue_date}}</h5>
            <h5 v-if="item.status.indexOf('1') !== -1">
              Estado: Enviada
            </h5>
            <h5 v-else>
              Estado: Anulada
            </h5>
            <h5>Fecha de Acuse: {{item.date_receipt}}</h5>
          </v-card-subtitle>
          <v-container v-if="item !== null">
              <v-card-text>
                <h1>Comentario: {{item.comment_receipt}}</h1>
              </v-card-text>
          </v-container>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="error darken-1"
              text
              @click="dialogReceipt = false"
            >
              Cerrar
            </v-btn>
          </v-card-actions>
        </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogStatusNumeration"
      max-width="620"
    >
      <v-card>
        <v-card-title class="headline">
          Este rango aún es editable y corregible.<br>
          Al activarlo quedará fijo y no se podrá editar.<br>
          ¿Está seguro de activarlo?
        </v-card-title>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            @click="dialogStatusNumeration = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            :loading="toggleStatusNumeration"
            @click.prevent="toggleActiveNumeration()"
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="dialogShowMovements"
        max-width="800"
      >
        <v-card>
          <v-card-title class="headline">
            Realizar Movimiento {{ this.titleAccount }}
          </v-card-title>
          <v-container>
            <v-form
              ref="form"
              lazy-validation
              @submit.prevent="reset"
              @keydown="form.onKeydown($event)"
            >
              <v-card-text>
                <v-select
                  v-model="form.type_service"
                  :items="services_types"
                  :rules="[rules.required]"
                  label="Tipo de Servicio"
                  required
                />
              </v-card-text>
              <v-card-text>
                <v-select
                  v-model="form.type_movement"
                  :items="filteredMovementTypes"
                  :rules="[rules.required]"
                  label="Tipo de Movimiento"
                  @change="showServices"
                  required
                />
              </v-card-text>
              <v-row>
                <v-col v-if="form.type_service && item">
                  <v-card-text>
                    <v-text-field
                      v-model="computedFieldValue"
                      :label="computedLabel"
                      maxlength="8"
                      readonly
                    />
                  </v-card-text>
                </v-col>
                <v-col>
                  <v-card-text>
                    <v-text-field
                      v-model="form.quantity"
                      label="Cantidad"
                      :rules="[rules.required, rules.numeric]"
                      maxlength="8"
                      required
                    />
                  </v-card-text>
                </v-col>
                <v-col cols="6" v-if="form.type_movement != 4 && form.type_movement != 3">
                  <v-card-text>
                    <v-text-field
                      v-model="form.description"
                      label="Concepto"
                      maxlength="150"
                      required
                    />
                  </v-card-text>
                </v-col>
              </v-row>
              <v-card-text v-if="form.type_movement == 4">
                <v-select
                  v-model="form.service_id"
                  :rules="[rules.required]"
                  :items="servicesList"
                  item-value="id"
                  label="Paquetes de Licencias"
                  required
                >
                  <template v-slot:selection="data">
                    <v-chip
                    :color="getColorService(data.item.available)"
                  >
                    <span v-if="data.item.available >= 1">
                      {{ data.item.service }} - {{ data.item.name }}
                      ({{ data.item.quantity }} Cantidad - {{ data.item.time }} meses)
                      Disponibles {{ data.item.available }}
                    </span>
                    <span v-else>
                      {{ data.item.service }} - {{ data.item.name }}
                      ({{ data.item.quantity }} Cantidad - {{ data.item.time }} meses)
                      Disponibles {{ data.item.available }}
                    </span>
                  </v-chip>
                  </template>
                  <template v-slot:item="data">
                      {{ data.item.service }} - {{ data.item.name }}
                      ({{ data.item.quantity }} Cantidad - {{ data.item.time }} meses)
                      Disponibles {{ data.item.available }}
                  </template>
                </v-select>
              </v-card-text>
              <v-row>
                <v-col cols="9">
                  <v-card-text v-if="form.type_movement == 3">
                    <v-text-field
                      v-model="form.account_ruc_dealer"
                      label="No. Cuenta o RIF del Distribuidor"
                      maxlength="150"
                      required
                    />
                  </v-card-text>
                </v-col>
                <v-col cols="3">
                  <v-tooltip bottom v-if="form.type_movement == 3">
                    <template v-slot:activator="{ on }">
                      <v-btn
                        color="blue darken-1"
                        @click="searchDealerAccount"
                        v-on="on"
                        :loading="searching || form.busy"
                      >
                        <v-icon
                          text
                        >
                          mdi-credit-card-search
                        </v-icon>
                      </v-btn>
                    </template>
                  </v-tooltip>
                </v-col>
              </v-row>
              <v-row  v-if="form.type_movement == 3">
                <v-col cols="4">
                  <v-card-text>
                    <v-text-field
                      v-model="dealer.razonSocial"
                      label="Razón Social"
                      placeholder="Distribuidor S.A."
                      readonly
                    />
                  </v-card-text>
                </v-col>
                <v-col cols="4">
                  <v-card-text>
                    <v-text-field
                      v-model="dealer.ruc"
                      label="RIF"
                      placeholder="155596713-2-2015"
                      readonly
                    />
                  </v-card-text>
                </v-col>
                <v-col cols="4">
                  <v-card-text>
                    <v-text-field
                      v-model="dealer.account_number"
                      label="No. Cuenta"
                      placeholder="CE6842F4-15CE-49FB-8F76-AFDA292202B9"
                      readonly
                    />
                  </v-card-text>
                </v-col>
              </v-row>
              <v-row v-if="form.type_movement == 5">
                <v-card-text>
                  <v-select
                      v-model="form.service_id"
                      :rules="[rules.required]"
                      :items="servicesDealerList"
                      item-value="id"
                      label="Paquetes de Licencias del Distribuidor"
                      required
                      @change="setEmployeesQuantityDealer"
                  >
                      <template v-slot:selection="data">
                        <v-chip
                          color="green"
                          dark
                        >
                          <span>
                            {{ data.item.service }} - {{ data.item.name }}
                            ({{ data.item.quantity }} - {{ data.item.time }} meses)
                            Disponibles {{ data.item.available }}
                          </span>
                        </v-chip>
                      </template>
                      <template v-slot:item="data">
                          {{ data.item.service }} - {{ data.item.name }}
                          ({{ data.item.quantity }} - {{ data.item.time }} meses)
                          Disponibles {{ data.item.available }}
                      </template>
                  </v-select>
                </v-card-text>
              </v-row>
            </v-form>
          </v-container>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="error darken-1"
              text
              @click="dialogShowMovements = false"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="green darken-1"
              text
              :loading="form.busy"
              :disabled="disabledAcceptTransaccion"
              @click.prevent="generateMovement()"
            >
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import * as _ from 'underscore';
  import Form from 'vform';
  import { mask } from 'vue-the-mask';
  import BackButton from './BackButton';

  export default {
    components: { BackButton },
    directives: {
      mask,
    },
    props: {
      headers: {
        type: Array,
        required: true,
      },
      apiURL: {
        type: String,
        required: true,
      },
      title: {
        type: String,
        required: true,
      },
      readonly: {
        type: Boolean,
        required: false,
        default: false,
      },
      readonlyEditar: {
        type: Boolean,
        required: false,
        default: false,
      },
      readonlyEliminar: {
        type: Boolean,
        required: false,
        default: false,
      },
      permisosNuevoRegistro: {
        type: String,
        required: false,
      },
      permisosEditar: {
        type: String,
        required: false,
      },
      permisosEliminar: {
        type: String,
        required: false,
      },
      permisosNuevoMovimiento: {
        type: String,
        required: false,
      },
      permisosHistorial: {
        type: String,
        required: false,
      },
      permisosAsociaciones: {
        type: String,
        required: false,
      },
      permisosDescargar: {
        type: String,
        required: false,
      },
      readonlyDate: {
        type: Boolean,
        required: false,
        default: false,
      },
      showSeries: {
        type: Boolean,
        required: false,
        default: false,
      },
      back: {
        type: Boolean,
        required: false,
        default: false,
      },
      backURL: {
        type: String,
        required: false,
      },
      queryParams: {
        type: String,
        required: false,
        default: '',
      },
      isDocuments: {
        type: Boolean,
        required: false,
        default: false,
      },
      isUsers: {
        type: Boolean,
        required: false,
        default: false,
      },
      isBatches: {
        type: Boolean,
        required: false,
        default: false,
      },
      isNumeration: {
        type: Boolean,
        required: false,
        default: false,
      },
      islazySearch: {
        required: false,
        default: false,
      },
      message: { default: '' },
      type: { default: '' },
      bus: { default: null },
      refresh: { default: false },
    },
    data: () => ({
      downloading: false,
      busy: false,
      loading: false,
      dialogGeneralAction: false,
      dialogGeneralActionPdf: false,
      linkSourcePdf: '',
      dialogReceipt: false,
      dialog: false,
      dialogStatus: false,
      dialogStatusForm: false,
      dialogStatusNumeration: false,
      dialogEmployees: false,
      dialogShowEmail: false,
      dialogShowSMS: false,
      reason: '',
      dateAnnulment: '',
      editedIndex: -1,
      options: {},
      search: '',
      items: [],
      totalItems: 0,
      footerOptions: { 'items-per-page-options': [10, 20, 30, 40, 50] },
      toggleStatus: false,
      toggleStatusForm: false,
      toggleStatusNumeration: false,
      toggleStatusDelete: false,
      toggleStatusEmployees: false,
      deleteID: '',
      issue_date: new Date().toISOString().substr(0, 10),
      item: null,
      menu2: false,
      menu: false,
      dialogShowMovements: false,
      disabledAcceptTransaccion: false,
      titleAccount: '',
      form: new Form({
        type_service: '',
        type_movement: '',
        quantity: '',
        description: '',
        service_id: '',
        incoming_account_id: '',
        dealer_id: '',
        account_ruc_dealer: '',
        busy: false,
      }),
      form2: new Form({
        id: '',
        type: '',
        mail: '',
        number_phone: '',
        send_type: 'correo',
        busy: false,
      }),
      form3: new Form({
        observation: '',
        busy: false,
      }),
      form5: new Form({
        id: '',
        type: '',
        number_phone: '',
        busy: false,
      }),
      dealer: {
        ruc: '',
        razonSocial: '',
        account_number: '',
        incoming_account_id: '',
      },
      services_types: [
        { value: 1, text: 'Imprenta Digital' },
        { value: 2, text: 'Nómina' },
      ],
      movement_types: [
        { value: 1, text: 'Entrada' },
        { value: 2, text: 'Salida' },
        { value: 3, text: 'Transferencia' },
        { value: 4, text: 'Conversión a Licencia' },
        { value: 5, text: 'Revertir Licencia' },
      ],
      servicesList: [],
      servicesDealerList: [],
      searching: false,
      rules: {
        required: (v) => !!v || 'El campo es requerido.',
        numeric: (v) => /^[0-9]*$/.test(v) || 'El campo solo permite caracteres numericos.',
        phoneLength: (v) => (!v || v.length === 16) || 'El campo debe tener de 14 caracteres numéricos.',
        wsLength: (v) => (!v || v.length === 14) || 'El campo debe tener de 12 caracteres numéricos.',
      },
      noReload: false,
      itemsTypeSend: [
        { value: 'correo', text: 'Correo' },
        { value: 'sms', text: 'SMS' },
        { value: 'whatsapp', text: 'Whatsapp' },
      ],
    }),
    watch: {
      options: {
        handler() {
          this.refreshTable();
        },
        deep: true,
      },
      search: {
        handler() {
          this.refreshTable();
        },
        deep: true,
      },
      apiURL: {
        handler() {
          this.refreshTable();
        },
        deep: true,
      },
      queryParams: {
        handler() {
          this.refreshTable();
        },
        deep: true,
      },
    },
    computed: {
      ...mapGetters({
        user: 'auth/user',
        taxpayer_rif: 'taxpayer/rif',
        loadingColor: 'theme/loadingColor',
        backgroundLoadingColor: 'theme/backgroundLoadingColor',
        themeColor: 'theme/themeColor',
        navbarColor: 'theme/navbarColor',
      }),
      computedLabel() {
        return this.form.type_service === 1 ? 'Folios Disponible' : 'Cupos Disponible';
      },
      computedFieldValue() {
        return this.form.type_service === 1 ? this.item.folios : this.item.employees;
      },
      filteredMovementTypes() {
        if (this.form.type_service === 1) {
          return this.movement_types.filter((item) => ![4, 5].includes(item.value));
        }
        return this.movement_types;
      },
    },
    mounted() {
      if (this.bus) this.bus.$on('refreshTable', this.refreshTable);
    },
    methods: {
      openModalPass(item) {
      const editedItem = item.id;
      this.$router.push({ path: `${this.$router.currentRoute.path}/${editedItem}/invoice`, params: { counterId: editedItem } });
    },
      showServices() {
        if (this.form.type_movement === 4 && this.servicesList.length === 0) {
          window.axios.get('/api/catalogs/getAllServices')
          .then((result) => {
            this.showAdd = !this.showAdd;
            this.servicesList = result.data.items;
          });
        } else if (this.form.type_movement === 3) {
          this.disabledAcceptTransaccion = true;
        } else if (this.form.type_movement === 5) {
          window.axios.get(`/api/catalogs/dealers/${this.item.dealer_id}/licences`)
          .then((result) => {
            const validItems = result.data.items.filter((service) => parseInt(service.available, 10) > 0);
            this.servicesDealerList = validItems;
            this.disabledAcceptTransaccion = true;
            this.form.service_id = '';
          });
        } else {
          this.showAdd = !this.showAdd;
          this.disabledAcceptTransaccion = false;
        }
      },
      setEmployeesQuantityDealer() {
        const selectedService = this.servicesDealerList.find((service) => service.id === this.form.service_id);
        this.form.employees = selectedService.cantidad;
        this.disabledAcceptTransaccion = false;
      },
      getColorService(available) {
        if (available >= 1) return 'green';
          return 'red';
      },
      debounceInput: _.debounce(function d(e) {
        this.search = e;
      }, 500),
      hasActionsSlot() {
        return !!this.$scopedSlots.actions;
      },
      refreshTable() {
        this.getDataFromApi()
        .then((data) => {
          this.items = data.items;
          this.totalItems = data.total;
        });
      },
      getDataFromApi() {
        this.loading = true;
        this.downloading = true;
        return new Promise(async (resolve) => {
          const {
            sortBy,
            sortDesc,
            page,
            itemsPerPage,
          } = this.options;
          const response = await this.getItems(page, itemsPerPage, sortBy, sortDesc).then((response) => {
              const data = response.data.items;
              const { total } = response.data;
              return ({ data, total } || []);
          });
          const items = response.data;
          const { total } = response;

          setTimeout(() => {
            this.loading = false;
            this.downloading = false;
            resolve({
              items,
              total,
            });
          }, 1000);
        });
      },
      getItems(page, itemsPerPage, sortBy, sortDesc) {
        let search = this.search;
        if (this.isDocuments === true) {
          search.replace('EMISOR', '');
          if (this.taxpayer_rif !== null) {
            search = `EMISOR: ${this.taxpayer_rif};${this.search}`;
          }
        }

        let url = `${this.apiURL}?currentPage=${page}&perPage=${itemsPerPage}
        &search=${search}&sortBy=${sortBy}&desc=${sortDesc}${this.queryParams}`;
        if (this.islazySearch) {
          url = `${this.apiURL}?currentPage=${page}&perPage=${itemsPerPage}
            &sortBy=${sortBy}&desc=${sortDesc}${this.queryParams}`;
        }
        const promise = window.axios.get(url).then();
        return promise;
      },
      newItem() {
        this.$router.push({ path: `${this.$router.currentRoute.path}/agregar` });
      },
      editItem(item) {
        const editedItem = item.id;
        if (this.isUsers) {
          this.$router.push({ path: `${this.$router.currentRoute.path}/editar`, name: 'editUser', params: { id: editedItem } });
        } else {
          this.$router.push({ path: `${this.$router.currentRoute.path}/${editedItem}/editar`, params: { id: editedItem } });
        }
      },
      historyItem(item) {
        const historyItem = { ...item };
        this.$router.push({ path: `${this.$router.currentRoute.path}/${historyItem.id}/historial`,
          params: { idHistory: historyItem.id } });
      },
      detailItem(item) {
        const detailItem = { ...item };
        this.$router.push({ path: `${this.$router.currentRoute.path}/${detailItem.id}/detalle`,
          params: { detailItemId: detailItem.id } });
      },
      trackingMail(item) {
        const history = { ...item };
        if (history.serie === '') {
            history.serie = 'SERIE';
        }
        this.$router.push({
          path: `${this.$router.currentRoute.path}/${history.enterprise_id}/${history.serie}/${history.type}/${history.document_number}/correo`,
          params: { enterprise_id: history.enterprise_id,
                    document_number: history.document_number } });
      },
      trackingSMS(item) {
        const history = { ...item };
        if (history.serie === '') {
            history.serie = 'SERIE';
        }
        this.$router.push({
          path: `${this.$router.currentRoute.path}/${history.enterprise_id}/${history.serie}/${history.type}/${history.document_number}/sms`,
          params: { enterprise_id: history.enterprise_id,
                    document_number: history.document_number } });
      },
      getGeneralAction(item) {
        this.dialogGeneralAction = true;
        this.item = item;
      },
      getGeneralActionPdf(item) {
        const url = '/api/documents/download_file';
        window.axios.post(url, {
            emisor_number_id: item.emisor_number_id,
            type_document: item.type,
            document_number: item.document_number,
            serie: item.serie,
            typeFile: 'pdf',
        }).then((response) => {
          this.busy = true;
          if (response.data) {
            this.linkSourcePdf = `data:application/pdf;base64,${response.data}`;

            setTimeout(() => { this.dowloading = false; }, 1000);

            this.dialogGeneralActionPdf = true;
            this.item = item;
          } else {
            this.$store.dispatch('notifications/show', {
              message: 'El documentos no contiene PDF.',
              type: 'error',
            });
          }
          this.busy = false;
          this.dialogGeneralAction = false;
        })
        .catch(() => {
        });
      },
      getReceipt(item) {
        this.dialogReceipt = true;
        this.item = item;
      },
      getJson(item) {
        const getItem = { ...item };
        const documentNumber = getItem.document_number.toString();
        const name = documentNumber.padStart(8, '0');
          const url = '/api/documents/download_file';
          window.axios.post(url, {
              emisor_number_id: item.emisor_number_id,
              type_document: item.type,
              document_number: item.document_number,
              serie: item.serie,
              typeFile: 'json',
          }).then((response) => {
            this.busy = true;
            if (response.data) {
              this.downloadFileJson(response, `${name}.json`);

              setTimeout(() => { this.dowloading = false; }, 1000);

              this.$store.dispatch('notifications/show', {
                message: 'Se ha descargado el archivo json con éxito.',
                type: 'success',
              });
              this.busy = false;
              this.dialogGeneralAction = false;
            } else {
              this.$store.dispatch('notifications/show', {
                message: 'El documentos no contiene archivo.',
                type: 'error',
              });
              this.busy = false;
              this.dialogGeneralAction = false;
            }
          })
          .catch(() => {
          });
      },
      getExcel(item) {
          const url = '/api/salebook/download_file';
          window.axios.post(url, {
              id: item.id,
              rif: item.rif,
          }).then((response) => {
            this.busy = true;
            if (response.data.code === 200) {
              this.downloadFileCsv(response, `Libro de Venta ${item.rif}`);

              setTimeout(() => { this.dowloading = false; }, 1000);

              this.$store.dispatch('notifications/show', {
                message: 'Se ha descargado el archivo excel con éxito.',
                type: 'success',
              });
              this.busy = false;
              this.dialogGeneralAction = false;
            } else {
              this.$store.dispatch('notifications/show', {
                message: 'El registro no contiene archivo.',
                type: 'error',
              });
              this.busy = false;
              this.dialogGeneralAction = false;
            }
          })
          .catch(() => {
          });
      },
      downloadItem(item) {
        const getItem = { ...item };
          const url = `${this.apiURL}/${getItem.id}/download`;
          window.axios({
            method: 'get',
            url,
          }).then((response) => {
            this.busy = true;
            if (response.data) {
              this.downloadFileTxt(response, `${getItem.name} - Version ${getItem.version}`);

              setTimeout(() => { this.dowloading = false; }, 1000);

               this.$store.dispatch('notifications/show', {
                message: 'Se ha descargado el archivo con éxito.',
                type: 'success',
              });
              this.busy = false;
            } else {
              this.$store.dispatch('notifications/show', {
                message: 'El documentos no contiene archivo.',
                type: 'error',
              });
              this.busy = false;
            }
          })
          .catch(() => {
          });
      },
      getXML(item) {
        const getItem = { ...item };
        const documentNumber = getItem.document_number.toString();
        const name = documentNumber.padStart(8, '0');
          const url = '/api/documents/download_file';
          window.axios.post(url, {
            emisor_number_id: item.emisor_number_id,
            type_document: item.type,
            document_number: item.document_number,
            serie: item.serie,
            typeFile: 'xml',
          }).then((response) => {
            this.busy = true;
            if (response.data) {
              this.downloadFile(response, `${name}`);

              setTimeout(() => { this.dowloading = false; }, 1000);

               this.$store.dispatch('notifications/show', {
                message: 'Se ha descargado el XML con éxito.',
                type: 'success',
              });
              this.busy = false;
              this.dialogGeneralAction = false;
            } else {
              this.$store.dispatch('notifications/show', {
                message: 'El documentos no contiene XML.',
                type: 'error',
              });
              this.busy = false;
              this.dialogGeneralAction = false;
            }
          })
          .catch(() => {
          });
      },
      getPDF(item) {
        const getItem = { ...item };
        const documentNumber = getItem.document_number.toString();
        const name = documentNumber.padStart(8, '0');
          const url = '/api/documents/download_file';
          window.axios.post(url, {
              emisor_number_id: item.emisor_number_id,
              type_document: item.type,
              document_number: item.document_number,
              serie: item.serie,
              typeFile: 'pdf',
          }).then((response) => {
            this.busy = true;
            if (response.data) {
              this.downloadFilePDF(response, `${name}`);

              setTimeout(() => { this.dowloading = false; }, 1000);

               this.$store.dispatch('notifications/show', {
                message: 'Se ha descargado el PDF con éxito.',
                type: 'success',
              });
              this.busy = false;
              this.dialogGeneralAction = false;
            } else {
              this.$store.dispatch('notifications/show', {
                message: 'El documentos no contiene PDF.',
                type: 'error',
              });
              this.busy = false;
              this.dialogGeneralAction = false;
            }
          })
          .catch(() => {
          });
      },
      getMail(item, canCorreo, canSms, canWhatsapp) {
        this.dialogShowEmail = true;
        this.item = item;
        this.itemsTypeSend = [];
        if (canCorreo) {
          this.itemsTypeSend.push({ value: 'correo', text: 'Correo' });
        }
        if (canSms) {
          this.itemsTypeSend.push({ value: 'sms', text: 'SMS' });
        }
        if (canWhatsapp) {
          this.itemsTypeSend.push({ value: 'whatsapp', text: 'Whatsapp' });
        }
      },
      sendMail() {
       if (this.$refs.form.validate()) {
          this.form2.busy = true;
          const url = '/api/documents/send-mail';
          window.axios.post(url, {
            enterprise_id: this.item.enterprise_id,
            emisor_number_id: this.item.emisor_number_id,
            type_document: this.item.type,
            document_number: this.item.document_number,
            serie: this.item.serie,
            mail: this.form2.mail,
          })
          .then((response) => {
            this.message = response.data.message;
            this.type = response.data.type;
            this.dialogShowEmail = false;
            this.form2.busy = false;
            this.resetForm();
            this.refreshTable();
          });
        }
      },
      getSendSMS(item) {
        this.dialogShowSMS = true;
        this.item = item;
      },
      sendSMS() {
       if (this.$refs.form.validate()) {
          this.form5.busy = true;
          const url = '/api/documents/send-sms';
          window.axios.post(url, {
            enterprise_id: this.item.enterprise_id,
            emisor_number_id: this.item.emisor_number_id,
            type_document: this.item.type,
            document_number: this.item.document_number,
            serie: this.item.serie,
            number_phone: this.form5.number_phone,
          })
          .then((response) => {
            this.message = response.data.message;
            this.type = response.data.type;
            this.dialogShowSMS = false;
            this.form5.busy = false;
            this.resetForm();
            this.refreshTable();
          });
        }
      },
      downloadFile(response, filename) {
        // Es necesario crear un nuevo objeto blob con mime-type establecido explícitamente
        // de lo contrario, solo Chrome funciona como debería  //application/vnd.ms-excel
        // application/application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
        const newBlob = new Blob([response.data], { type: 'xml' });
        // IE no permite usar un objeto blob directamente como enlace href, en su lugar, es necesario usar msSaveOrOpenBlob
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob);
          return;
        }
        // Para otros navegadores: Cree un enlace que apunte al ObjectURL que contiene el blob..
        const data = window.URL.createObjectURL(newBlob);
        const link = document.createElement('a');
        link.href = data;
        link.download = `${filename }.xml`;
        link.click();
        setTimeout(() => {
          // Para Firefox es necesario retrasar la revocación de ObjectURL
          window.URL.revokeObjectURL(data);
        }, 100);
      },
      downloadFileTxt(response, filename) {
        // Es necesario crear un nuevo objeto blob con mime-type establecido explícitamente
        // de lo contrario, solo Chrome funciona como debería  //application/vnd.ms-excel
        // application/application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
        const newBlob = new Blob([response.data], { type: 'txt' });
        // IE no permite usar un objeto blob directamente como enlace href, en su lugar, es necesario usar msSaveOrOpenBlob
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob);
          return;
        }
        // Para otros navegadores: Cree un enlace que apunte al ObjectURL que contiene el blob..
        const data = window.URL.createObjectURL(newBlob);
        const link = document.createElement('a');
        link.href = data;
        link.download = `${filename}.txt`;
        link.click();
        setTimeout(() => {
          // Para Firefox es necesario retrasar la revocación de ObjectURL
          window.URL.revokeObjectURL(data);
        }, 100);
      },

      downloadFilePDF(response, filename) {
        const linkSource = `data:application/pdf;base64,${response.data}`;
        const downloadLink = document.createElement('a');
        const fileName = `${filename }.pdf`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      },
      downloadFileExcel(response, filename) {
        const linkSource = `data:application/vnd.ms-excel;base64,${response.data.file}`;
        const downloadLink = document.createElement('a');
        const fileName = `${filename }.xls`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      },
      downloadFileCsv(response, filename) {
        const newBlob = new Blob([atob(response.data.file)], { type: 'csv' });
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob);
          return;
        }
        const data = window.URL.createObjectURL(newBlob);
        const link = document.createElement('a');
        link.href = data;
        link.download = `${filename}.csv`;
        link.click();
        setTimeout(() => {
          window.URL.revokeObjectURL(data);
        }, 100);
      },
      downloadFileJson(response, filename) {
        const newBlob = new Blob([response.data], { type: 'json' });
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob);
          return;
        }
        const data = window.URL.createObjectURL(newBlob);
        const link = document.createElement('a');
        link.href = data;
        link.download = `${filename}`;
        link.click();
        setTimeout(() => {
          window.URL.revokeObjectURL(data);
        }, 100);
      },
      openModalDelete(item) {
       this.dialog = true;
       this.item = item;
      },
      deleteItem() {
        this.toggleStatusDelete = true;
        const url = `${this.apiURL}/${this.item.id}`;
        window.axios.delete(url)
        .then((response) => {
          this.$store.dispatch('notifications/show', {
            message: response.data.message,
            type: response.data.type,
          });
          this.toggleStatusDelete = false;
          this.dialog = false;
          this.getDataFromApi()
          .then((data) => {
            this.items = data.items;
            this.totalItems = data.total;
          });
        });
      },
      reset() {
        this.search = '';
      },
      openModalStatus(item) {
       this.dialogStatus = true;
       this.item = item;
      },
      openModalStatusForm(item) {
       this.dialogStatusForm = true;
       this.item = item;
      },
      openModalStatusNumeration(item) {
        if (item.active === 0) {
          this.dialogStatusNumeration = true;
          this.item = item;
        }
      },
      validateMotivo() {
        if (this.$refs.form3.validate()) {
          this.toggleActive();
        }
      },
      toggleActive() {
          this.toggleStatus = true;
          const url = `${this.apiURL}/${this.item.id}/toggle`;
          window.axios.post(url, {
            observation: this.form3.observation,
          })
            .then((response) => {
              this.toggleStatus = false;
              this.$store.dispatch('notifications/show', {
                message: response.data.message,
                type: response.data.type,
              });
              this.refreshTable();
              this.dialogStatus = false;
              this.item.active = !this.item.active;

              if (this.isUsers === true) {
                this.resetForm3();
              }
            });
      },
      toggleActiveUser() {
          this.toggleStatusForm = true;
          const url = `${this.apiURL}/${this.item.id}/toggle`;
          window.axios.post(url)
            .then((response) => {
              this.toggleStatusForm = false;
              this.$store.dispatch('notifications/show', {
                message: response.data.message,
                type: response.data.type,
              });
              this.refreshTable();
              this.dialogStatusForm = false;
              this.item.active = !this.item.active;
            });
      },
      toggleActiveNumeration() {
          this.toggleStatusNumeration = true;
          const url = `${this.apiURL}/${this.item.id}/toggle`;
          window.axios.post(url, {
            observation: this.form3.observation,
          })
            .then((response) => {
              this.toggleStatusNumeration = false;
              this.$store.dispatch('notifications/show', {
                message: response.data.message,
                type: response.data.type,
              });
              this.refreshTable();
              this.dialogStatusNumeration = false;
              this.item.active = !this.item.active;

              if (this.isUsers === true) {
                this.resetForm3();
              }
            });
      },
      goBack() {
        if (this.backURL) { this.$router.push({ name: this.backURL }); } else { this.$router.go(-1); }
      },
      getColor(status) {
        if (status.indexOf('1') !== -1) return 'green';
        return 'red';
      },
      resetForm() {
        this.$refs.form.reset();
      },
      resetForm3() {
        this.$refs.form3.reset();
      },
      reload() {
        this.noReload = true;
        this.refreshTable();
        setTimeout(() => {
          this.noReload = false;
        }, 7500);
      },
      sendType() {
       if (this.$refs.form.validate()) {
          this.form2.busy = true;
          if (this.form2.send_type === 'correo') {
            const url = '/api/documents/send-mail';
            window.axios.post(url, {
              enterprise_id: this.item.enterprise_id,
              emisor_number_id: this.item.emisor_number_id,
              type_document: this.item.type,
              document_number: this.item.document_number,
              serie: this.item.serie,
              mail: this.form2.mail,
            })
            .then((response) => {
              this.message = response.data.message;
              this.type = response.data.type;
              this.dialogShowEmail = false;
              this.form2.busy = false;
              this.resetForm();
              this.refreshTable();
            });
          } else if (this.form2.send_type === 'sms') {
            this.form2.busy = true;
            const url = '/api/documents/send-sms';
            window.axios.post(url, {
              enterprise_id: this.item.enterprise_id,
              emisor_number_id: this.item.emisor_number_id,
              type_document: this.item.type,
              document_number: this.item.document_number,
              serie: this.item.serie,
              number_phone: this.form2.number_phone,
              })
              .then((response) => {
                this.message = response.data.message;
                this.type = response.data.type;
                this.dialogShowEmail = false;
                this.form2.busy = false;
                this.resetForm();
                this.refreshTable();
              });
          } else if (this.form2.send_type === 'whatsapp') {
            this.form2.busy = true;
            const url = '/api/documents/send-whatsapp';
            window.axios.post(url, {
              enterprise_id: this.item.enterprise_id,
              emisor_number_id: this.item.emisor_number_id,
              type_document: this.item.type,
              document_number: this.item.document_number,
              serie: this.item.serie,
              number_phone: this.form2.number_phone,
            })
            .then((response) => {
              this.message = response.data.message;
              this.type = response.data.type;
              this.dialogShowEmail = false;
              this.form2.busy = false;
              this.resetForm();
              this.refreshTable();
            });
          }
        }
      },
      openModalMovements(item) {
        this.dialogShowMovements = true;
        this.item = item;
        this.titleAccount = this.item.razonSocial;
      },
      generateMovement() {
        if (this.$refs.form.validate()) {
          this.form.busy = true;
          const url = '/api/history/store';
          window.axios.post(url, {
            type_service: this.form.type_service,
            quantity: this.form.quantity,
            description: this.form.description,
            type_movement: this.form.type_movement,
            service: this.form.service_id,
            outgoing_account_id: this.item.id,
            incoming_account_id: this.dealer.incoming_account_id,
            dealer_id: this.item.dealer_id,
          })
          .then((response) => {
              this.type = response.data.type;
              this.message = response.data.message;
              this.form.busy = false;
            if (this.type === 'success') {
              this.dialogShowMovements = false;
              this.resetForm();
              this.refreshTable();
            } else {
              this.dialogShowMovements = true;
              this.form.quantity = '';
            }
          });
        }
      },
      searchDealerAccount() {
        if (this.form.account_ruc_dealer) {
          this.searching = true;
          const url = `/api/getAccount/${this.form.account_ruc_dealer}`;
          window.axios.get(url)
          .then((response) => {
            if (response.data.type === 'success') {
                this.dealer.ruc = response.data.item.identificacion;
                this.dealer.razonSocial = response.data.item.razonSocial;
                this.dealer.account_number = response.data.item.account_number;
                this.dealer.incoming_account_id = response.data.item.id;
                this.disabledAcceptTransaccion = false;
            }
            this.$store.dispatch('notifications/show', {
              message: response.data.message,
              type: response.data.type,
            });
            this.searching = false;
          });
        } else {
          this.$store.dispatch('notifications/show', {
            message: 'Introduzca un número de identificación.',
            type: 'error',
          });
        }
      },
      redirectToConsulta(item) {
        const url = '/api/receipt/link_consulta';
        window.axios.post(url,
          {
            emisor_number_id: item.emisor_number_id,
            receiver_number_id: item.receiver_number_id,
            serie: item.serie,
            document_number: item.document_number,
            document_type: item.type,
            control_number: item.control_number,
          })
          .then((response) => {
            window.open(response.data.url, '_blank');
          });
      },
    },
  };
</script>
